export default {
  title: 'Kontakty',
  description: 'Na této stránce naleznete naše kontaktní údaje nebo nás můžete přímo kontaktovat pomocí kontaktního formuláře.',
};
